<template>
    <div class="app-containerTeach">
    <el-row class="headTop">
      <span v-if="showShop">
        分店：<el-select class="w150 mr20" v-model="params.shopNum" style="width:200px" clearable placeholder="请选择">
          <el-option v-for="item in this.shopList"
          :key="item.shopNum"
          :label="item.name"
          :value="item.shopNum"
          ></el-option>
        </el-select>
      </span>
        订单状态：<el-select class="w150 mr20" v-model="params.type" style="width:200px" clearable placeholder="请选择">
        <el-option v-for="item in this.suatus"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          ></el-option>
        </el-select>
        <el-button style="width:100px" type="primary" @click="query()">查询</el-button>
    </el-row>
    <el-dialog title="排课"  :visible.sync="dialogVisible" width="1000px">
        <el-form :model="formparams" :rules="rules" ref="formparams" label-width="100px">
          <el-form-item label="上课日期" prop="recorddate">
            <el-date-picker
              v-model="formparams.recorddate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="上课日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="上课教室" prop="classroom">
            <el-select v-model="formparams.classroom" placeholder="请选择">
              <el-option v-for="item in this.roomList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上课时间">
            <el-time-select
              placeholder="起始时间"
              v-model="startTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00'
              }">
            </el-time-select>
            <el-time-select
              placeholder="结束时间"
              v-model="endTime"
              :picker-options="{
                start: '00:00',
                step: '00:30',
                end: '24:00',
                minTime: startTime
              }">
            </el-time-select>
          </el-form-item>
          <el-form-item label="选择教练" prop="teacherName">
            <el-select v-model="formparams.teacherName" placeholder="请选择">
              <el-option v-for="item in this.optionsJL"
              :key="item.name"
              :label="item.name"
              :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="最大人数" prop="maxRenshu">
            <el-input v-model.number="formparams.maxRenshu" placeholder="请输入上课人数"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button style="width:100px"  @click="resetForm('formparams')">取 消</el-button>
            <el-button style="width:100px"  type="primary" @click="submitForm('formparams')">确 定</el-button>
        </span>
    </el-dialog>
    <el-row class="tableList">
      <el-table v-loading="loading" :data="tableData" height="73vh" border stripe>
        <el-table-column
          label="序号"
          type="index"
          width="50">
        </el-table-column>
        <el-table-column prop="name" width="100" label="会员姓名"></el-table-column>
        <el-table-column prop="money" width="100" label="金额"></el-table-column>
        <el-table-column prop="jiaoyihao" width="220" label="交易单号"></el-table-column>
        <el-table-column label="支付方式">
           <template slot-scope="scope">
            <div v-if="scope.row.type=='card'">会员卡</div>
            <div v-else-if="scope.row.type=='wx'">微信</div>
            <!-- <div v-else-if="scope.row.status==2">退款失败</div> -->
          </template>
        </el-table-column>
        <el-table-column prop="applicationtime" width="200" label="申请时间"></el-table-column>

        <el-table-column prop="billnum" width="300" label="订单号"></el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status==0">申请成功</div>
            <div v-else-if="scope.row.status==1">退款成功</div>
            <div v-else-if="scope.row.status==2">退款失败</div>
          </template>
        </el-table-column>
        <el-table-column label="分店">
          <template slot-scope="scope">
            <div> {{scope.row.shopnum|caseType}} </div>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="说明"></el-table-column>
        <el-table-column label="操作">
            <template slot-scope="scope">
            <el-button v-if="scope.row.status==2" style="width:100px"  type="primary" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="pageination">
      <el-col>
        <el-pagination
          style="textAlign:center;marginTop:10px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[20, 40, 80, 100]"
          :page-size="20"
          layout="total, sizes, prev, pager, next, jumper"
          :total="this.total"
        ></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
let that;
import {getRefundRecords, getShops, updateRefundRecords } from "../../api/configApi";
// import mainHead from "../../components/mainHead/mainHead";
export default {
  data() {
    return {
      loading: true,
      dialogVisible: false,
      showShop: false,
      date:[],//开始时间结束时间
      rules:{
        classroom:[
          { required: true, message: '请选择教室', trigger: 'change' }
        ],
        recorddate:[
          { required: true, message: '请选择时间', trigger: 'change' }
        ],
        teacherName:[
          { required: true, message: '请选择教师', trigger: 'change' }
        ],
        maxRenshu:[
          { required: true, message: '人数不能为空'},
          { type: 'number', message: '人数必须为数字值'}
        ]
      },
      startTime:'',
      endTime:'',
      suatus:[
        {label:'申请成功', value:0},
        {label:'退款成功', value:1},
        {label:'退款失败', value:2},

      ],
      addType:1,
      formparams:{
        code:'',
        recorddate:'',
        classroom:'',
        courseTime:'',
        courseName:'',
        courseType:'',
        teacherName:'',
        maxRenshu:'',
        shopNum:''
      },
      formData:{},
      fileList:[],//图片回显示
      tableData:[],
      optionsJL:[],//私教列表
      classProject:[],//团课项目
      roomList:[],
      //分店列表
      shopList:[],
      shopListAll:JSON.parse(sessionStorage.getItem('shopListAll')),
      shopListIsweb:[],
      total: 0,
      currentPage: 1,
      params: {
        pageNo: 1,
        pageSize: 20,
        type:'',
        shopNum:null
      }
    }
  },
  filters:{
    caseType(value) {
      if (that.shopListAll.find(i => {
        return i.shopNum == value
        })) {
        return that.shopListAll.find(i => {
            return i.shopNum == value
        }).name
      }
    }
  },
  components: {
    // mainHead
  },
  beforeCreate(){
    that = this;
  },
  created(){
    if(sessionStorage.getItem('shopList')){
      this.shopList = JSON.parse(sessionStorage.getItem('shopList'))
      if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
        this.params.shopNum = this.shopList[0].shopNum
        this.showShop = false
      }else{
        this.showShop = true
      }
    } else{
      this.getShopsList()
    }
  },
  mounted() {
    this.getTableList()
  },
  methods: {
    //查询课程
    // getTbCourse(){
    //   getTbCourse().then((res)=>{
    //     console.log(res)
    //     this.classProject = res.data
    //   })
    // },
    //查询退款列表
    getTableList(){
      getRefundRecords(this.params).then((res)=>{
        if(res.msg == "success"){
            this.tableData = res.data.info
            this.total = res.data.total
        }
        this.loading = false
      })
    },
    //查询分店类型
    getShopsList(){
      getShops({isWeb:1}).then((res)=>{
        this.shopList = res.data
        // sessionStorage.setItem('shopList',JSON.stringify(res.data))
        if(JSON.parse(sessionStorage.getItem('userinfo')).shopNum!=null){
          this.params.shopNum = this.shopList[0].shopNum
          this.showShop = false
        } else {
          this.showShop = true
        }
      })
    },
    query(){
      this.params.pageNo=1
      this.currentPage = 1;
      this.getTableList()
    },
    //编辑
    edit(row){
      this.$confirm('确定退款业务已经完成，退款状态改变不可撤销 ', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateRefundRecords({id:row.id}).then(res=>{
          if(res.msg=='success'){
            this.$message({
              type: 'success',
              message: '修改成功!'
            }); 
            this.getTableList()

          }else {
             this.$message({
              type: 'error',
              message: res.data
            }); 
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取修改'
          })    
      })
    },
    //添加票
    // insertOnlineTicketInfo
    submitForm(formparams){
      this.$refs[formparams].validate(valid => {
        if (valid) {
          this.formparams.courseTime = this.startTime+'-'+this.endTime
            updateTuancaorec(this.formparams).then((res)=>{
              if(res.msg=="success"){
                this.$message({
                  type:'success',
                  message:'修改成功'
                })
              } else{
                this.$message.error(res.data)
              }
              this.dialogVisible = false
              this.getTableList()
            })
        } else {
          this.$message.error('请检查必填项');
          return false;
        }
      });
    },
    //取消
    resetForm(formparams) {
      this.dialogVisible = false;
      this.$refs[formparams].clearValidate();
    },
      //分页
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.params.pageNo = 1;
      this.currentPage = 1;
      this.getTableList()
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getTableList()
    },
  }
};
</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// refundMoney.vue?fcbbbe0e